import { NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE_CATEGORY } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { DrillDownParamsOriginal, EntityOriginal, ListResponse } from './types'

import type { ReportEntityWithQuantity } from '../../drilldown/types'

type ProductGroup = ReportEntityWithQuantity & {
  productGroupId: number
  productGroupName: string
}

type ProductGroupResponse = ListResponse<ProductGroup> & {
  category: EntityOriginal
}

export const IS_NEW_BACKEND_API = true

export const getDrillDownGroups = async (params: DrillDownParamsOriginal) => {
  const query = new URLSearchParams({ ...params })

  const groupResult = await get<ProductGroupResponse>(
    `${NEW_API_ROUTE_ADMIN_DRILL_DOWN_SERVICE_CATEGORY}?${query.toString()}`,
    IS_NEW_BACKEND_API
  )

  return {
    ...groupResult,
    rows: groupResult.rows.map(group => ({
      ...group,
      amount: Number(group.amount),
      salaryDeductionAmount: Number(group.salaryDeductionAmount),
    })),
  }
}
